import { procoreClient } from "./client";

type Uuid = string;

export type BimModelRevision = {
    id: Uuid;
    bim_model_id: Uuid;
    bim_file_id: number;
    current_platform_scene_id: Uuid;
    current_platform_scene_version_id?: Uuid | null;
    revision_number: number;
};

/**
 * Tries multiple query-param variants to find BIM model revisions.
 * Returns the first non-empty result, or an empty array.
 */
export async function getBimModelRevisions(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
    sceneVersionId?: string;
}): Promise<BimModelRevision[]> {
    const { companyId, projectId, sceneId, sceneVersionId } = params;

    const basePath = `/rest/v2.0/companies/${companyId}/projects/${projectId}/bim/model_revisions`;

    const candidates = getBimModelRevisionParamCandidates({ sceneId, sceneVersionId });

    for (const query of candidates) {
        try {
            const response = await procoreClient<{ data: BimModelRevision[] }>(
                `${basePath}?${new URLSearchParams(query)}`,
                { method: "GET" },
            );
            if (response.data.length > 0) {
                return response.data;
            }
        } catch {
            console.error("Failed to get BIM model revisions with query:", query);
        }
    }

    return [];
}

export function getBimModelRevisionParamCandidates(params: {
    sceneId: string;
    sceneVersionId?: string;
}): Record<string, string>[] {
    const { sceneId, sceneVersionId } = params;

    const candidates: Record<string, string>[] = [];

    if (sceneVersionId) {
        if (sceneId !== sceneVersionId) {
            candidates.push({ external_scene_version_id: sceneVersionId, external_scene_id: sceneId });
        }
        candidates.push({ external_scene_version_id: sceneVersionId });
    } else if (sceneId) {
        candidates.push({ external_scene_version_id: sceneId });
    }

    if (sceneId) {
        candidates.push({ external_scene_id: sceneId });
        candidates.push({ "filters[current_platform_scene_id]": sceneId });
    }

    return candidates;
}
